import * as React from 'react';

import { getAvailableLocalesForUser } from 'bundles/common/utils/localeUtils';

import _t from 'i18n!nls/account-settings';

type Props = {
  defaultValue: string;
  onChange: React.ChangeEventHandler<HTMLSelectElement>;
};

class LanguageSelect extends React.Component<Props> {
  render() {
    const { defaultValue, onChange } = this.props;

    const locales = getAvailableLocalesForUser();

    // empty string is the value for no default language
    const selected = locales.find((locale) => locale.key === defaultValue) ? defaultValue : '';

    return (
      <select
        key={`languageSelect~${defaultValue}`}
        name="locale"
        id="settings-basic-language"
        defaultValue={selected}
        onChange={onChange}
        autoComplete="language"
      >
        <option value="" disabled>
          {_t('Select a language')}
        </option>
        {locales.map(({ key, label }) => (
          <option key={key} value={key}>
            {label}
          </option>
        ))}
      </select>
    );
  }
}

export default LanguageSelect;
